module.exports = __webpack_public_path__ + "static/media/2.26bf9463.jpg";